import Sidebar from "./Sidebar";
import MobileDrawer from "./MobileDrawer";
import Footer from "./Footer";
import NotificationBell from "./NotificationBell";
import DatabaseBackupButton from "./DatabaseBackupButton";
import { useAuth } from "../context/AuthContext";

export default function Layout({ children, title, subtitle, actions }) {
    const { user } = useAuth();
    const canBackup = user?.role === "superadmin" && user?.active !== false;
    return (
        <div className="min-h-screen bg-slate-50 flex">
            <Sidebar />
            <main className="relative flex-1 min-w-0 flex flex-col">
                <header className="flex items-center gap-3 px-4 py-3 bg-slate-900 border-b border-slate-800 sticky top-0 z-30 md:absolute md:top-6 md:right-8 md:p-0 md:bg-transparent md:border-0">
                    <div className="md:hidden"><MobileDrawer /></div>
                    <div className="md:hidden flex items-center">
                        <img src="/logo-emprenovus.png" alt="Emprenovus" className="h-9 w-auto object-contain" data-testid="mobile-header-logo" />
                    </div>
                    <div className="ml-auto flex items-center gap-2">
                        <DatabaseBackupButton />
                        <NotificationBell responsive />
                    </div>
                </header>
                <div className="flex-1 px-4 sm:px-6 lg:px-10 py-6 lg:py-10 max-w-[1600px] mx-auto w-full">
                    {(title || actions) && (
                        <div className={`flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 ${canBackup ? "md:pr-40" : "md:pr-12"}`}>
                            <div>
                                {title && <h1 className="text-2xl sm:text-3xl font-display font-semibold tracking-tight text-slate-900">{title}</h1>}
                                {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
                            </div>
                            {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
                        </div>
                    )}
                    {children}
                </div>
                <Footer />
            </main>
        </div>
    );
}
